import React from "react";
import { IconsProps } from "./dto.ts";

export function ClockIcon(props: IconsProps) {
    return (
        <svg className="cursor-pointer" width={props.size} height={props.size} onClick={(e) => props.onClick && props.onClick(e)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}